import { RasterAttributes } from "models/model";

/**
 * 9-color RdYlBu palette used for GeoTIFF value-based colorbars.
 * Mirrors the palette in GeoTiffDetails.tsx (single source of truth for the
 * panel and the map-screenshot legend).
 */
export const IpdbColors = [
  "#3288bd",
  "#66c2a5",
  "#abdda4",
  "#e6f598",
  "#ffffbf",
  "#fee08b",
  "#fdae61",
  "#f46d43",
  "#d53e4f"
];

export type GeoTiffColorbarItem = {
  color: string;
  title: number;
};

/**
 * Build the 9-step discrete colorbar items for a GeoTIFF raster attribute range.
 * Replicates the exact step math from GeoTiffDetails.tsx getLegendItems:
 *   step = (max - min) / 8, loop i = 0..8, title = Math.round(start * 100) / 100.
 *
 * Missing/undefined rasterAttributes → [].
 */
export function buildGeoTiffColorbarItems(
  rasterAttributes?: Maybe<RasterAttributes>
): GeoTiffColorbarItem[] {
  if (!rasterAttributes) {
    return [];
  }
  const { min, max } = rasterAttributes;
  const diff = max - min;
  const steps = diff / 8.0;
  let start = min;
  const items: GeoTiffColorbarItem[] = [];
  for (let i = 0; i <= 8; i++) {
    items.push({
      color: IpdbColors[i],
      title: Math.round(start * 100.0) / 100.0
    });
    start += steps;
  }
  return items;
}
